import dataOccupations from './data.json'
import { useEffect, useState } from 'react'
import { useFirebolt } from '@iq-firebolt/client'

const useOccupation = ({ 
		fireboltStep,
	}) => {
	const [occupationId, setOccupationId] = useState(null)

	const onChangeStepField = (value) => {
		const occupationValue = value?.occupation_info
		setOccupationId(occupationValue)
    const isOccupationField = occupationValue && occupationId !== occupationValue

		if (isOccupationField) {
			occupationFilter(occupationValue)
		}
	}

	const formatWorkFields = (workTypeFields) => {
		return workTypeFields.map(({ type_id, type_description }) => ({
			value: type_id.padStart(4, '0'),
			label: type_description,
		}))
	}

	const occupationFilter = (value) => {
		const filterOccupationId = ({ occupation_id }) => Number(occupation_id) == value
		const filterResult = dataOccupations.filter(filterOccupationId)
		const workFieldsFormatted = formatWorkFields(filterResult)
		updateWorkTypeField(workFieldsFormatted)
		toogleWorkTypeField({ type: 'remove' })
	}

	const updateWorkTypeField = (updatedWorkFields) => {
		const workTypeIndex = fireboltStep.fields.findIndex(({ slug }) => slug === 'work_type')

		fireboltStep.fields[workTypeIndex] = {
			...fireboltStep.fields[workTypeIndex],
			['ui:props']: {
				...fireboltStep.fields[workTypeIndex]['ui:props'],
				options: updatedWorkFields
			}
		}
	}

	const toogleWorkTypeField = ({ type = 'add' }) => {
		const workTypeInput = document.querySelector('[name="work_type"]')

		if (type === 'add') {
			workTypeInput.setAttribute('disabled', true)
		} else if(type === 'remove') {
			workTypeInput.removeAttribute('disabled')
			workTypeInput.selectedIndex = 0
		}
	}

	useEffect(() => {
		toogleWorkTypeField({ 
			type: 'add' 
		})
	}, [])

	return {
		onChangeStepField,
	}
}

export default useOccupation